import {
  RouteReuseStrategy,
  DetachedRouteHandle,
  ActivatedRouteSnapshot
} from '@angular/router';

export class SimpleReuseStrategy implements RouteReuseStrategy {
  private stored: Record<string, DetachedRouteHandle> = {};
  private maxEntries = 10; // prevent unbounded memory growth

  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    return !!route.data?.['reuse'];
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    // use the route’s URL (or path) as the key:
    const key = route.routeConfig?.path ?? '';
    this.stored[key] = handle;
    // Evict oldest if over capacity
    const keys = Object.keys(this.stored);
    if (keys.length > this.maxEntries) {
      const oldestKey = keys[0];
      delete this.stored[oldestKey];
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    const key = route.routeConfig?.path ?? '';
    return !!route.data?.['reuse'] && !!this.stored[key];
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    const key = route.routeConfig?.path ?? '';
    return this.stored[key] || null;
  }

  // Allow manual cache clear on logout/navigation if needed
  clear(): void {
    this.stored = {};
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return future.routeConfig === curr.routeConfig;
  }
}
